enum Environments {
  local = 'local',
  development = 'development',
  qa = 'qa',
  production = 'production',
}

export default Environments;
